export const deserializeSubagentInfo = (userInfo) => {
    if (userInfo && (userInfo.whatsapp_number === '' || userInfo.whatsapp_number == null)) {
        return {
            ...userInfo,
            whatsapp_number: undefined,
        };
    } else return userInfo;
};
